/**
 * LUFE "Buscar en la nube" applies to Argentina Cementos post-balance only.
 * Uruguay must not show the action (OP #52583).
 */
export function shouldShowPostBalanceCloudSearch(
  isUruguayEnabled: boolean | undefined | null,
): boolean {
  return isUruguayEnabled !== true;
}
